import { Tooltip } from 'antd'

import cn from './EllipsisText.module.scss'

type EllipsisTextProps = {
  text: string
  tooltipMinLength?: number
}

function EllipsisText({ text, tooltipMinLength }: EllipsisTextProps) {
  const content = <span className={cn.ellipsis}>{text}</span>

  if (tooltipMinLength === undefined || text.length <= tooltipMinLength) {
    return content
  }

  return <Tooltip title={text}>{content}</Tooltip>
}

export default EllipsisText
